module.exports = __webpack_public_path__ + "static/img/12.7740140.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/12.png
// module id = fZQV
// module chunks = 0